import { useEffect } from 'react';
import { uniq } from 'lodash-es';
import {
  inHouseJackpotsActions,
  useGetMissingGameIds
} from '../../jackpotsStore';

export const useLoadInHouseJackpotWinnersInfo = (winnersGamesLaunchIds) => {
  const { FETCH_IN_HOUSE_JACKPOT_WINNERS_GAMES } = inHouseJackpotsActions;

  const missingGameIds = useGetMissingGameIds(winnersGamesLaunchIds);

  useEffect(() => {
    if (missingGameIds.length) {
      FETCH_IN_HOUSE_JACKPOT_WINNERS_GAMES(uniq(missingGameIds));
    }
  }, [missingGameIds]);
};
